import { useSession } from "../session";

export const useUserId = () => {
  const { data: session } = useSession();
  return session?.userId as string;
};
